import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CentsCurrencyPipe } from '@common/centsCurrency.pipe';
import { CardComponent } from '@components/card/card.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-order-complete-summary',
  templateUrl: './order-complete-summary.component.html',
  styleUrls: ['./order-complete-summary.component.scss'],
  imports: [CardComponent, NgFor, NgIf, CentsCurrencyPipe],
})
export class OrderCompleteSummaryComponent {
  @Input() public orderId: string = '';
  @Input() public orderTotal: number = 0;
  @Input() public paymentIds: string[] = [];
  @Input() public testsOrdered: string[] = [];

  public get orderedTestWording(): { single: string; plural: string } {
    return environment.order.orderComplete.testOrderedWording;
  }
}
